//generic
export default {
  showError({ commit }, text) {
    let payload = {
      open: true,
      text: text,
      color: 'error'
    };
    commit('SET_SNACKBAR', payload);
  },
};
